
import React, { useState } from 'react';
import { Send } from 'lucide-react';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, isLoading }) => {
  const [input, setInput] = useState('');

  const handleSendMessage = () => {
    if (input.trim()) {
      onSendMessage(input);
      setInput('');
    }
  };

  return (
    <div className="p-4 border-t border-gray-200/50 flex items-center bg-white/60 backdrop-blur-lg">
      <input 
        type="text" 
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
        placeholder="Ask me anything about your form..."
        className="flex-grow border border-gray-200 rounded-l-lg p-2 bg-white/80 text-black focus:outline-none focus:ring-2 focus:ring-[#0a0c1b]"
      />
      <button 
        onClick={handleSendMessage} 
        disabled={isLoading}
        className="bg-[#0a0c1b]/80 text-white p-2 rounded-r-lg hover:bg-[#1c2435] disabled:opacity-50 transition-colors"
      >
        <Send className="h-5 w-5" />
      </button>
    </div>
  );
};

export default ChatInput;
